module.exports = __webpack_public_path__ + "img/emergency.eab323c6.png";